import TokenAnalyzerWalletStatsItem from "./TokenAnalyzerWalletStatsItem";

export default TokenAnalyzerWalletStatsItem;